<template>
    <div class="absorptiveRate">
        <div class="leader-tab">
            <el-tabs v-model="tabVal" type="card" @tab-click="handleClick">
                <el-tab-pane
                    v-for="item in tabs"
                    :key="item.tree_unit_id"
                    :label="item.name"
                    :name="item.tree_unit_id"
                ></el-tab-pane>
            </el-tabs>
        </div>
        <el-form class="leader-style-form" inline>
            <el-form-item
                label="日期"
                label-width="40px"
                v-if="currentIndex == 1"
            >
                <el-date-picker
                    v-model="show_day"
                    type="date"
                    format="yyyy-MM-dd"
                    clearable="false"
                    value-format="yyyy-MM-dd"
                    @change="handleFilterList()"
                    placeholder="选择日期"
                    :picker-options="pickerOptions"
                    style="float:left"
                ></el-date-picker>
            </el-form-item>
            <el-form-item label="月份" label-width="40px" v-else>
                <el-date-picker
                    v-model="show_day"
                    type="month"
                    format="yyyy-MM"
                    clearable="false"
                    value-format="yyyy-MM"
                    @change="handleFilterList()"
                    placeholder="选择日期"
                    :picker-options="pickerOptions"
                    style="float:left"
                ></el-date-picker>
            </el-form-item>
            
        </el-form>
        <div class="card-box">
            <div :class="[currentIndex == 1 ? 'card-box-item card-box-item_s' : 'card-box-item card-box-item_us']" @click="clickItem(1)">
                <div class="card-box-item-img">
                    <img
                        src="../../../assets/image/use_electricity_monitor/day.jpg"
                    />
                </div>
                <div class="card-box-item-title">日</div>

                <div style="width: 64%;">
                    <div class="card-box-item-content">
                        {{ active_power_day }}
                        <div class="unit">
                            {{ unit_day }}
                        </div>
                    </div>
                </div>
                <div class="card-box-item-arrow">
                    <img
                        src="../../../assets/image/use_electricity_monitor/arrow.jpg"
                    />
                </div>
            </div>
            <div :class="[currentIndex == 2 ? 'card-box-item card-box-item_s' : 'card-box-item card-box-item_us']" @click="clickItem(2)">
                <div class="card-box-item-img">
                    <img
                        src="../../../assets/image/use_electricity_monitor/month.jpg"
                    />
                </div>
                <div class="card-box-item-title">月</div>
                <div style="width: 64%;">
                    <div class="card-box-item-content">
                        {{ active_power_month }}
                        <div class="unit">
                            {{ unit_month }}
                        </div>
                    </div>
                </div>
                <div class="card-box-item-arrow">
                    <img
                        src="../../../assets/image/use_electricity_monitor/arrow.jpg"
                    />
                </div>
            </div>
            <div :class="[currentIndex == 3 ? 'card-box-item card-box-item_s' : 'card-box-item card-box-item_us']" @click="clickItem(3)">
                <div class="card-box-item-img">
                    <img
                        src="../../../assets/image/use_electricity_monitor/year.jpg"
                    />
                </div>
                <div class="card-box-item-title">年</div>
                <div style="width: 64%;">
                    <div class="card-box-item-content">
                        {{ active_power_year }}
                        <div class="unit">
                            {{ unit_year }}
                        </div>
                    </div>
                </div>
                <div class="card-box-item-arrow">
                    <img
                        src="../../../assets/image/use_electricity_monitor/arrow.jpg"
                    />
                </div>
            </div>
        </div>
        <div class="echart-container">
            <v-chart
                :auto-resize="true"
                :options="line"
                ref="line"
                theme="ovilia-green"
            />
        </div>
    </div>
</template>
<script>
import * as api from "@/http/api.js";
import "echarts/lib/chart/line";
import "echarts/lib/component/title";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/legend";
import "echarts/lib/component/toolbox";
import "echarts/lib/component/markPoint";
export default {
    data() {
        return {
            tabVal: "",
            tabs: [],
            show_day: "",
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() > Date.now();
                }
            },
            active_power_day: "",
            active_power_month: "",
            active_power_year: "",
            unit_day: '',
            unit_month: '',
            unit_year: '',
            legend: "",
            xAxis: [],
            yAxis: [],
            currentIndex: 1
        };
    },
    created() {
        this.getSysDate();
    },
    methods: {
        getSysDate() {
            api.getSysDate().then(res => {
                if (res && res.error_code == 0) {
                    this.show_day = res.bus_json.sysdate;
                    this.getAbsorptiveRateParams();
                }
            });
        },
        getAbsorptiveRateParams() {
            api.getAbsorptiveRateParams().then(res => {
                if (res && res.error_code == 0) {
                    this.tabs = res.bus_json;
                    this.tabVal = this.tabs[0].tree_unit_id;
                    this.getActivePowerSum(this.tabVal);
                    this.getAbsorptiveRateList(this.tabVal);
                }
            });
        },
        handleClick(tab) {
            this.tabVal = tab.name;
            this.getActivePowerSum(this.tabVal);
            this.getAbsorptiveRateList(this.tabVal);
        },
        handleFilterList() {
            this.getActivePowerSum(this.tabVal);
            if (this.currentIndex == 1) {
                this.getAbsorptiveRateList(this.tabVal);
            } else if (this.currentIndex == 2) {
                // 月
                this.getAbsorptiveRateMonth(
                    this.tabVal,
                    this.show_day.substring(0, 7)
                );
            } else if (this.currentIndex == 3) {
                // 年
                this.getAbsorptiveRateYear(
                    this.tabVal,
                    this.show_day.substring(0, 7)
                );
            }
        },
        getActivePowerSum(tree_unit_id) {
            api.getActivePowerSum({
                tree_unit_id,
                show_day: this.show_day
            }).then(res => {
                if (res && res.error_code == 0) {
                    if (res.bus_json == null) return;
                    if (tree_unit_id == "1607650868665954304") {
                        this.active_power_day =
                            "消纳率: " + res.bus_json.active_power_day &&
                            res.bus_json.active_power_day;
                        this.active_power_month =
                            "消纳率: " + res.bus_json.active_power_month &&
                            res.bus_json.active_power_month;
                        this.active_power_year =
                            "消纳率: " + res.bus_json.active_power_year &&
                            res.bus_json.active_power_year;
                        this.unit_day = "%";
                        this.unit_month = "%";
                        this.unit_year = "%";
                    } else if (tree_unit_id == "1608279677787443200") {
                        this.active_power_day =
                            "光伏发电量: " + res.bus_json.active_power_day &&
                            res.bus_json.active_power_day;
                        this.active_power_month =
                            "光伏发电量: " +
                                res.bus_json.active_power_month &&
                            res.bus_json.active_power_month;
                        this.active_power_year =
                            "光伏发电量: " + res.bus_json.active_power_year &&
                            res.bus_json.active_power_year;
                        this.unit_day = res.bus_json.active_power_day_unit;
                        this.unit_month = res.bus_json.active_power_month_unit;
                        this.unit_year = res.bus_json.active_power_year_unit;
                    }
                }
            });
        },
        clickItem(index) {
            this.currentIndex = index;
            if (index == 1) {
                this.getAbsorptiveRateList(this.tabVal);
            } else if (index == 2) {
                // 月
                this.getAbsorptiveRateMonth(
                    this.tabVal,
                    this.show_day.substring(0, 7)
                );
            } else if (index == 3) {
                // 年
                this.getAbsorptiveRateYear(
                    this.tabVal,
                    this.show_day.substring(0, 7)
                );
            }
        },
        // 日
        getAbsorptiveRateList(tree_unit_id) {
            api.getAbsorptiveRateList({
                tree_unit_id,
                show_day: this.show_day
            }).then(res => {
                if (res && res.error_code == 0) {
                    if (tree_unit_id == "1607650868665954304") {
                        this.legend = "消纳率";
                    } else if (tree_unit_id == "1608279677787443200") {
                        this.legend = "光伏发电量";
                    }
                    this.xAxis = res.bus_json.x_list;
                    this.yAxis = res.bus_json.y_list;
                }
            });
        },
        // 月
        getAbsorptiveRateMonth(tree_unit_id, show_day) {
            api.getAbsorptiveRateMonth({
                tree_unit_id,
                show_day
            }).then(res => {
                if (res && res.error_code == 0) {
                    if (tree_unit_id == "1607650868665954304") {
                        this.legend = "消纳率";
                    } else if (tree_unit_id == "1608279677787443200") {
                        this.legend = "光伏发电量";
                    }
                    this.xAxis = res.bus_json.x_list;
                    this.yAxis = res.bus_json.y_list;
                }
            });
        },
        // 年
        getAbsorptiveRateYear(tree_unit_id, show_day) {
            api.getAbsorptiveRateYear({
                tree_unit_id,
                show_day
            }).then(res => {
                if (res && res.error_code == 0) {
                    if (tree_unit_id == "1607650868665954304") {
                        this.legend = "消纳率";
                    } else if (tree_unit_id == "1608279677787443200") {
                        this.legend = "光伏发电量";
                    }
                    this.xAxis = res.bus_json.x_list;
                    this.yAxis = res.bus_json.y_list;
                }
            });
        }
    },
    computed: {
        line() {
            const options = {
                title: {
                    // text: '变压器负载率趋势图'
                },
                grid: {
                    left: "3%",
                    right: "0%",
                    bottom: "15%",
                    top: "10%",
                    containLabel: true
                },
                tooltip: {
                    trigger: "axis"
                },
                legend: {
                    data: [this.legend],
                    textStyle: {
                        color: "#fff"
                    }
                },
                calculable: true,
                xAxis: [
                    {
                        type: "category",
                        data: this.xAxis,
                        axisLabel: {
                            //y轴文字的配置
                            textStyle: {
                                color: "#fff"
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: "#fff" // 颜色
                            }
                        }
                    }
                ],
                yAxis: [
                    {
                        // name: "单位(kWh)",
                        type: "value",
                        axisLabel: {
                            //y轴文字的配置
                            textStyle: {
                                color: "#fff"
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: "#fff" // 颜色
                            }
                        }
                    }
                ],
                series: [
                    {
                        name: this.legend,
                        type: "line",
                        data: this.yAxis,
                        itemStyle: {
                            normal: {
                                color: "#0191e7", //点颜色
                                lineStyle: {
                                    color: "#0191e7" //线颜色
                                }
                            }
                        },
                        smooth: true,
                        symbol: "none"
                    }
                ]
            };
            return options;
        }
    }
};
</script>
<style lang="scss">
.absorptiveRate {
    width: 100%;
    height: 100%;
    padding: 0 40px;
    box-sizing: border-box;
    .card-box {
        width: 100%;
        display: flex;
        justify-content: space-between;
        .card-box-item {
            // width: 30%;
            flex: 1;
            display: flex;
            height: 110px;
            margin: 10px;
            align-items: center;
            cursor: pointer;
            .card-box-item-img {
                margin-left: 7%;
                img {
                    width: 2.5rem;
                    height: 2.5rem;
                }
            }
            .card-box-item-arrow {
                img {
                    width: 1.6rem;
                    height: 1.6rem;
                }
            }
            .card-box-item-title {
                color: #56fcff;
                // @include font_color;
                font-size: 28px;
                text-align: left;
                padding: 0.8rem;
            }
            .card-box-item-content {
                color: #fff;
                font-size: 28px;
                text-align: right;
                padding: 0px 20px;
                .unit {
                    font-size: 24px;
                    display: inline;
                }
            }
        }
        .card-box-item_s {
            width: 100%;
            background: url("../../../assets/image/custom/xnl_s.png")
                no-repeat;
            background-size: 100% 100%;
        }
        .card-box-item_us {
            width: 100%;
            background: url("../../../assets/image/custom/xnl_us.png")
                no-repeat;
            background-size: 100% 100%;
        }
        .pink {
            width: 100%;
            background: url("../../../assets/image/use_electricity_monitor/pinkBG.png")
                no-repeat;
            background-size: 100% 100%;
        }
        .perple {
            width: 100%;
            background: url("../../../assets/image/use_electricity_monitor/perpleBG.png")
                no-repeat;
            background-size: 100% 100%;
        }
        .yellow {
            width: 100%;
            background: url("../../../assets/image/use_electricity_monitor/yellowBG.png")
                no-repeat;
            background-size: 100% 100%;
        }
    }
    .echart-container {
        width: 100%;
        margin-top: 20px;

        .echarts {
            width: 100% !important;
            height: 450px;
        }
    }
}
</style>
